import React, { Component } from 'react';
import 'semantic-ui-css/semantic.min.css';
import Login from './views/login';
import Dashboard from './views/dashboard';
import PlanView from './views/plan';
import ResetPassword from './views/password/reset';
import ChangePassword from './views/password/change';

import './App.css';
import history from './history'
import { Provider } from 'react-redux';
import { store } from './store';

import { Router, Route } from 'react-router-dom'
import {
  DASHBOARD_PATH,
  LOGIN_PATH,
  LOAD_PLAN_PATH,
  PASSWORD_RESET_PATH,
  PASSWORD_CHANGE_PATH } from './constants'

class App extends Component {
  constructor(props){
    super(props);
    this.state = {}
  }

  render() {
    return (
      <Provider store={store}>
        <div className="app">
          <Router history={history}>
            <div>
              <Route exact path={LOGIN_PATH} component={Login}/>
              <Route exact path={DASHBOARD_PATH} component={Dashboard}/>
              <Route exact path={LOAD_PLAN_PATH} component={PlanView}/>
              <Route exact path={PASSWORD_RESET_PATH} component={ResetPassword}/>
              <Route exact path={PASSWORD_CHANGE_PATH} component={ChangePassword}/>
            </div>
          </Router>
        </div>
      </Provider>

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js